var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column mt-2"},[_c('ConditionsPreview',{attrs:{"value":_vm.value}}),_c('ConditionsModal',{attrs:{"value":_vm.value},on:{"input":function($event){return _vm.edit($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }